<app-header #get_value label="States" sub_label="Add State"></app-header>
<div class="rounded-2xl border border-[#E4E7EC] flex flex-col w-full overflow-x-auto relative print-section   gap-5 mb-4 h-[calc(100%-90px)] overflow-y-auto">
    <div class="flex h-full overflow-y-auto no-scrollbar flex-col bg-white rounded-2xl shadow w-full gap-4">
        <div class="flex items-center justify-between px-6 pt-6">
            <ng-container>
                <span class="text-xl font-medium leading-[100%] tracking-2p">Add State</span>
            </ng-container>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 p-4 pb-24">
            <app-text-input [is_required]=" true" type="text" class="w-full !m-0 !p-0" label="Name"></app-text-input>
            <app-text-input [is_required]="true" [type_total_latter]="10" class="w-full" [label]="'State Code'" formControlName="state_code"></app-text-input>
            <app-select-input [is_required]="true" type="text" class="w-full !m-0 !p-0" label="Country Name" [options]="[{title:'India',value:'India'}]"></app-select-input>
            <app-text-input disabled="true" [is_required]="true" type="text" class="w-full !m-0 !p-0" label="Created At"></app-text-input>
            <app-text-input disabled="true" [is_required]="true" type="text" class="w-full !m-0 !p-0" label="Updated At"></app-text-input>
        </div>

        <div class="flex absolute rounded-b-2xl px-6 py-4 items-center justify-end gap-6 w-full bottom-0 border-t border-gray-200 bg-white">
            <app-button [routerLink]="['/state/list']" color="border-[#3F41D1] text-[#3F41D1]" label="Cancel"></app-button>
            <app-button [routerLink]="['/state/list']" color="bg-[#E697AB] text-[#310000]" label="SUBMIT"></app-button>
        </div>
    </div>
</div>